import axios from 'axios'
import { config } from '../../config/config'

export const getAddressesByPostCode = (postcode) => axios.get(`${config.apiURL}/api/energy/addresses?postcode=${postcode}`)
